import { render, staticRenderFns } from "./IconQualify.vue?vue&type=template&id=ff2d499a&"
import script from "./IconQualify.vue?vue&type=script&lang=js&"
export * from "./IconQualify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports